<p-progressSpinner *ngIf="spinner"></p-progressSpinner>
<div class="panel_wrapper">
    <div class="d-flex flex-row justify-content-between pb-4">

        <div class="d-flex flex-row" style="align-items: self-end;width: 50%;">
            <img class="user_picture"
                [src]="!appUserModel.profilePictureUrl ? imagePath :appUserModel.profilePictureUrl "
                alt="profile-picture">
        </div>
    </div>
    <div class="pt-4 lh-1">
        <label class="user_name"><i *ngIf="!appUserModel.active" class="pi pi-user-minus user_susp"></i>{{
                appUserModel.firstName }} {{ appUserModel.lastName }}</label>
        <label class="user_location">{{ appUserModel.city }}, {{ appUserModel.country }}</label>
    </div>
    <div class="d-flex flex-row justify-content-between pb-4">
        <div style="width: 100%; ">
            <label style="margin-top: 0px;" class="user_label">{{ 'EMAIL' | translate }}<i
                    class="pi pi-envelope h6 m-0 float-end"></i></label>
            <label class="input_text_field">{{ appUserModel.email }}</label>
        </div>
    </div>
    <div class="d-flex flex-row justify-content-between pb-4">

        <div style="width: 100%; ">
            <label style="margin-top: 0px;" class="user_label">{{ 'PHONE' | translate }}<i
                    class="pi pi-phone h6 m-0 float-end"></i></label>
            <label class="input_text_field">{{ appUserModel.phone }}</label>
        </div>
        <div style="width: 100%; ">
            <label style="margin-top: 0px;" class="user_label">{{ 'BIRTHDAY' | translate }}<i
                    class="pi pi-calendar h6 m-0 float-end"></i></label>
            <label class="input_text_field">{{ appUserModel.dateOfBirth }}</label>
        </div>
    </div>
</div>
<p-toast position="top-center" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"></p-toast>